import { Component, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { CustomerInfoActions } from '../account/user-profile/user-profile.actions'
import { selectAppState } from '../app.root.state'
import { FormState } from 'ngrx-forms'
import { Observable } from 'rxjs'
import { selectProfileState } from '../account/user-profile/user-profile.state'
import { Subscriptions } from '../utils/subscriptions'
import { tap } from 'rxjs/operators'
import { Router } from '@angular/router'
import { KeycloakData } from '../account/user-profile/user-profile.reducers'
import { PendingState } from '../account/account.root.state'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'cover-uuidnot-found',
  templateUrl: './uuidnot-found.component.html',
  styleUrls: ['./uuidnot-found.component.scss'],
})
export class UUIDNotFoundComponent implements OnDestroy {
  $uuidNotFoundState: Observable<FormState<string>> | undefined
  $keycloakData: Observable<KeycloakData> | undefined
  kcEmail: string | undefined
  firstName: string | undefined
  lastName: string | undefined
  subscriptions = new Subscriptions()
  c4LoginFailedAttempts = 0
  currentPendingState = ''
  readonly pendingStateEnum = PendingState
  readonly environment = environment

  constructor(private readonly store: Store, private readonly router: Router) {
    this.$uuidNotFoundState = store.select(selectAppState.uuidNotFoundControls)
    this.$keycloakData = store.select(selectProfileState.keycloakData)
    this.subscriptions.plusOne = this.$keycloakData
      .pipe(
        tap(keycloakData => {
          this.kcEmail = keycloakData.kcEmail
          this.firstName = keycloakData.kcFirstName
          this.lastName = keycloakData.kcLastName
        }),
      )
      .subscribe()
    this.subscriptions.plusOne = store
      .select(selectProfileState.c4SessionId)
      .pipe(
        tap(sessionId => {
          if (sessionId) this.router.navigateByUrl('/navigation')
        }),
      )
      .subscribe()
    this.subscriptions.plusOne = store
      .select(selectProfileState.c4LoginState)
      .pipe(
        tap(c4LoginPendingState => {
          this.currentPendingState = c4LoginPendingState
          if (c4LoginPendingState === PendingState.failed) this.c4LoginFailedAttempts = this.c4LoginFailedAttempts + 1
        }),
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  isInvalidInput(input: string): boolean {
    return !input || isNaN(Number(input))
  }

  submit(customerNumber: string): void {
    this.store.dispatch(
      CustomerInfoActions.c4LoginLoad({
        payload: {
          uuidAuthent: `${this.kcEmail};${customerNumber.trim()}`,
        },
      }),
    )
  }

  protected readonly isNaN = isNaN
  protected readonly Number = Number
}
